import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { from, Observable, of } from 'rxjs';
import { AppCheckTokenResult } from '@firebase/app-check';
import { switchMap, take, catchError } from 'rxjs/operators';
import { AppCheckService } from '../services/app-check.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppCheckInterceptor implements HttpInterceptor {

  constructor(private readonly appCheckService: AppCheckService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only apply App Check to API calls that need it
    if (!this.shouldApplyAppCheck(request.url)) {
      return next.handle(request);
    }

    return from(this.appCheckService.getToken()).pipe(
      take(1),
      switchMap((token: AppCheckTokenResult | undefined) => {
        if (token?.token) {
          console.log('🔑 Adding App Check token to request:', request.url);
          request = request.clone({
            setHeaders: { 
              "X-Firebase-AppCheck": token.token 
            },
          });
        } else {
          console.warn('⚠️ No App Check token available for request:', request.url);
          
          // In production, you might want to handle this differently
          if (environment.production) {
            console.warn('🚨 Production API call without App Check token may fail');
          }
        }
        return next.handle(request);
      }),
      catchError((error) => {
        console.error('❌ App Check token retrieval failed for request:', request.url, error);
        
        // Continue with request even if App Check fails (fallback behavior)
        // You might want to change this based on your security requirements
        return next.handle(request);
      })
    );
  }

  /**
   * Determine if App Check should be applied to this request
   */
  private shouldApplyAppCheck(url: string): boolean {
    // Apply App Check to your API endpoints
    const apiEndpoints = [
      environment.ESCALAS_WSPREFIX,
      environment.AWS_REST_WSPREFIX,
      environment.TASK_REST_WSPREFIX,
      // Add other endpoints that require App Check
    ];

    // Check if the URL starts with any of the API endpoints
    return apiEndpoints.some(endpoint => url.startsWith(endpoint));
  }
}